import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Collapse, FormControl, List, ListItem, ListItemText, Typography } from "@material-ui/core";
import { SidePanelDrawer, NestedListItem } from "./AdminPanel.styled";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { Link, TextField } from "components";
import { useDebounce } from "hooks";
import { useAdminPanel, useAdminMenu } from "components/AdminPanel/hooks";

export const AdminPanel: React.FC = () => {
    const { t } = useTranslation();
    const isPanelVisible = useAdminPanel();
    const [searchPhrase, setSearchPhrase] = useState("");
    const debouncedSearchPhrase = useDebounce(searchPhrase, 200);
    const { sideMenu, setMenuItems } = useAdminMenu(debouncedSearchPhrase);

    if (!isPanelVisible) {
        return null;
    }

    return (
        <SidePanelDrawer variant="permanent" anchor="left">
            <Typography component="div" variant="subtitle2">
                <Box p={2} fontWeight="fontWeightBold">
                    {t("adminPanel.label.adminPanel")}
                    <FormControl fullWidth={true}>
                        <TextField
                            name="searchPhrase"
                            label={t("adminPanel.label.search")}
                            value={searchPhrase}
                            onChange={(e) => setSearchPhrase(e.target.value)}
                        />
                    </FormControl>
                </Box>
            </Typography>
            <List>
                {sideMenu.panel.map(({ name, submenu }, index) => (
                    <React.Fragment key={index}>
                        <ListItem button={true} onClick={setMenuItems(index)}>
                            <ListItemText disableTypography={true}>
                                <Typography component="div" variant="subtitle1">
                                    <Box fontWeight="fontWeightBold">{t(name)}</Box>
                                </Typography>
                            </ListItemText>
                            {!sideMenu.menuItems[index].isCollapsed ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={!sideMenu.menuItems[index].isCollapsed} timeout="auto" unmountOnExit={true}>
                            <List component="div" disablePadding={true}>
                                {submenu.map(({ name: submenuItemName, url }) => {
                                    return (
                                        <NestedListItem key={submenuItemName} button={true}>
                                            <ListItemText disableTypography={true}>
                                                <Link to={url} color="black">
                                                    <Typography variant="subtitle2">{t(submenuItemName)}</Typography>
                                                </Link>
                                            </ListItemText>
                                        </NestedListItem>
                                    );
                                })}
                            </List>
                        </Collapse>
                    </React.Fragment>
                ))}
            </List>
        </SidePanelDrawer>
    );
};
